import styled from "styled-components";
import Box from "../box/Box";
export const StyledTabPanel = styled(Box).withConfig({ displayName: "StyledTabPanel_APC-7311-productShell", componentId: "sc-k7czig" })({
    width: "100%",
});
//# sourceMappingURL=TabPanel.style.js.map